module.exports = __webpack_public_path__ + "static/media/card-preventiva.28ebafbb.svg";